import React from 'react';
import { colors, Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { EM_DASH } from '../../../../Base.constants';
import styles from './MetricChangeIcon.module.scss';

const cx = classNames.bind(styles);

interface MetricChangeProps {
  displayValue: string;
  value: number | undefined;
  previousValue: number | undefined;
  dataTestIdPrefix?: string;
}

const renderChangeArrow = (change: number | null, dataTestIdPrefix = '') => {
  if (change === null) {
    return null;
  }
  if (change < 0) {
    return (
      <Icon
        name={ICONS.TriangleDown}
        width={8}
        height={6}
        color={colors.high100}
        dataTestId={`${dataTestIdPrefix}triangle-down-icon`}
      />
    );
  }
  if (change > 0) {
    return (
      <Icon
        name={ICONS.TriangleUp}
        width={8}
        height={6}
        color={colors.low100}
        dataTestId={`${dataTestIdPrefix}triangle-up-icon`}
      />
    );
  }
  return null;
};

const MetricChangeIcon = ({
  displayValue,
  value,
  previousValue,
  dataTestIdPrefix,
}: MetricChangeProps): React.ReactElement | null => {
  if (displayValue == null || value == null) {
    return <div>{EM_DASH}</div>;
  }
  const change = previousValue != null ? value - previousValue : null;
  return (
    <div className={cx('body')}>
      {renderChangeArrow(change, dataTestIdPrefix)}
      {displayValue}
    </div>
  );
};

export default MetricChangeIcon;
